import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchReservationExportUrl } from '../../sagas/routines';
import {
  clearReservationExportUrl,
  setReservationExportInProgress
} from '../../actions/export';

const initialState = {
  inProgress: '',
  presignedUrl: '',
  fetching: false
};

const fetchInventoryExportUrlHandler = routine => ({
  [routine.REQUEST]: set('fetching', true),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    inProgress: '',
    presignedUrl: response.presignedUrl
  }),
  [routine.FULFILL]: set('fetching', false)
});

const clearHandler = action => ({
  [action.toString()]: set('presignedUrl', '')
});

const setInventoryExportInProgressHandler = action => ({
  [action.toString()]: (state, { payload: type }) =>
    set('inProgress', type, state)
});

export default createReducer(initialState, {
  ...fetchInventoryExportUrlHandler(fetchReservationExportUrl),
  ...setInventoryExportInProgressHandler(setReservationExportInProgress),
  ...clearHandler(clearReservationExportUrl)
});
